export default __webpack_public_path__ + "static/media/sauna.3970f50f.png";